import type { TrainingParticipant } from "@repo/app-types/entities/trainingParticipant";
import type { TrainingParticipantChapterGradingId } from "@repo/app-types/entities/trainingParticipantChapterGrading";
import { type FC, useState } from "react";
import { Heading } from "react-aria-components";
import { ChapterAssessmentDetails } from "./chapterAssessmentDetails.js";
import { ChapterGradingSelect } from "./chapterGradingSelect.js";

export interface ChapterDetailProps {
  projectId: string;
  participantId: string;
  chapterId: string;
  chapterNumber: number | undefined;
  participant: TrainingParticipant | undefined;
}

export const ChapterDetail: FC<ChapterDetailProps> = (props) => {
  const [selectedGradingId, setSelectedGradingId] =
    useState<TrainingParticipantChapterGradingId | null>(null);

  return (
    <>
      <div className="flex items-center justify-between gap-3">
        <Heading
          level={3}
          className="truncate text-base leading-7 font-semibold text-foreground"
        >
          {props.chapterNumber !== undefined
            ? `Chapter ${props.chapterNumber}`
            : null}
        </Heading>

        <div className="-my-1">
          <ChapterGradingSelect
            projectId={props.projectId}
            participantId={props.participantId}
            chapterId={props.chapterId}
            value={selectedGradingId}
            onChange={setSelectedGradingId}
          />
        </div>
      </div>

      <ChapterAssessmentDetails
        projectId={props.projectId}
        participantId={props.participantId}
        chapterId={props.chapterId}
        assessment={props.participant?.assessment?.chapters[props.chapterId]}
        selectedGradingId={selectedGradingId}
      />
    </>
  );
};
